module.exports = __webpack_public_path__ + "static/usecase_phone-9b9e30113a5785e15756ec7fe7559008.png";